// src/helpers/factories/settings/roleDetailsFactory.ts
var REGISTER_CASH_PAYMENT_OPTIONS = [
  "Pay to Drawer Only" /* PAY_TO_DRAWER_ONLY */,
  "Pay to Server Bank Only" /* PAY_TO_SERVER_BANK_ONLY */
];
var roleRegisterCashPaymentOptionsFactory = (t) => [
  {
    label: t("commonTexts.all"),
    value: -1
  },
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.drawers.cashPaymentOptions.options.payToDrawerOnly"
    ),
    value: REGISTER_CASH_PAYMENT_OPTIONS.indexOf(
      "Pay to Drawer Only" /* PAY_TO_DRAWER_ONLY */
    ) + 1
  },
  {
    label: t(
      "settingsModule.roleDetailsSettings.register.drawers.cashPaymentOptions.options.payToServerBankOnly"
    ),
    value: REGISTER_CASH_PAYMENT_OPTIONS.indexOf(
      "Pay to Server Bank Only" /* PAY_TO_SERVER_BANK_ONLY */
    ) + 1
  }
];

export { REGISTER_CASH_PAYMENT_OPTIONS, roleRegisterCashPaymentOptionsFactory };
